import styles from '@/components/models/accommodation/AccommodationBlock/AccommodationBlock.module.scss'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { TitleH2 } from '@/components/cms/Title'
import { useTranslation } from 'next-i18next'
import AccommodationDetailed from '@/components/models/accommodation/AccommodationDetailed'
import travelAccommodationAssignmentObject from '@/entities/travelAccommodationAssignment/interface'

interface Props {
  accommodationAssignments: travelAccommodationAssignmentObject[]
}

function getVisibleRoomTypes(accommodationAssignment: travelAccommodationAssignmentObject) {
  if (!accommodationAssignment.useCustomRoomTypeSelection) {
    return accommodationAssignment.accommodation.roomTypes
  }
  // @ts-ignore
  const roomTypeIds = accommodationAssignment.roomTypeIds
  return accommodationAssignment.accommodation.roomTypes.filter((roomType) => !!roomTypeIds?.includes(roomType.id!))
}

function getContent(accommodationAssignments: travelAccommodationAssignmentObject[]) {
  return (
    <>
      {accommodationAssignments.map((accommodationAssignment: travelAccommodationAssignmentObject, index: number) => {
        return (
          <div key={index}>
            <AccommodationDetailed
              accommodation={accommodationAssignment.accommodation}
              roomTypes={getVisibleRoomTypes(accommodationAssignment)}
              detailed={accommodationAssignment.displayDetails}
              imagePosition={index % 2 === 0 ? 'left' : 'right'}
            />
          </div>
        )
      })}
    </>
  )
}

const AccommodationBlock = ({ accommodationAssignments }: Props) => {
  const { t } = useTranslation('common')

  if (accommodationAssignments.length) {
    return (
      <div className={styles.root}>
        <Container className={'mb-2'}>
          <span id="accommodation" className="anchor" />
          <Row>
            <Col>
              <TitleH2 title={t(accommodationAssignments.length == 1 ? 'travel.accommodation' : 'travel.accommodations')} withDecoration={true} />
            </Col>
          </Row>
        </Container>
        {getContent(accommodationAssignments)}
      </div>
    )
  }

  return <></>
}

export default AccommodationBlock
